import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ChangePasswordService } from './change-password.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordValidator } from '../A2-utils/change-password/password-validator';
import { constant } from 'app/app.constants';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';


@Component({
  selector: 'app-change-password-new',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePassForm: FormGroup;
  saving = false;
  @Input() enforcePassword: boolean;

  @Output() EmitterAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() EmitterProgress: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    protected service: ChangePasswordService,
    fb: FormBuilder,
    private toastrAlertHelper: ToastrAlertHelper
  ) {
    this.changePassForm = fb.group({
      oldpassword : ['', Validators.required],
      newpassword : ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      confirmpassword : ['', Validators.required]
    }, {
      validator: PasswordValidator.passwordMatch('newpassword')
    });
  }

  saveAction() {
    if (this.changePassForm.get('newpassword').value === this.changePassForm.get('confirmpassword').value) {
      this.saving = true;
      this.service
        .changePass(this.changePassForm.value)
        .finally(() => {
          this.saving = false;
          return this.EmitterProgress.emit(false);
        })
        .subscribe(
          data => this.processdData(data),
          err => this.showError(err)
      );

      return this.EmitterProgress.emit(true);

    } else {
      this.toastrAlertHelper.error('Password does not match');
    }
  }

  processdData(data) {
    this.toastrAlertHelper.info(data.message);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    currentUser.reenterpassword = false;
    window.localStorage.setItem('currentUser', JSON.stringify(currentUser));
    this.changePassForm.reset();
    return this.EmitterAction.emit({isChange: true, closed: true});
  }

  showError(err) {
    this.toastrAlertHelper.error(err.message);
    return this.EmitterAction.emit({isChange: false, closed: false});
  }

  cancel (event) {
    return this.EmitterAction.emit({isChange: false, closed: true});
  }

  ngOnInit() {
    if (this.enforcePassword) {
      this.changePassForm.get('newpassword').setValidators(Validators.compose([
        Validators.required,
        PasswordValidator.pattern(/\d/, { hasNumber: true }),
        PasswordValidator.pattern(/[A-Z]/, { hasCapitalCase: true }),
        PasswordValidator.pattern(/[a-z]/, { hasSmallCase: true }),
        PasswordValidator.pattern(/[!%&'()*+./;<=>?\\,/:#@\t\r\n"\[\]_\u007B-\u00BF-]/, { hasSpecialCharacters: true }),
        Validators.minLength(constant.ENFORCED_PASSWORD_MIN_LENGTH)
      ]));
    }
  }

 /**
   * this validate if password contain an error
   * @param error
   */
  validateError(error): boolean {
    return this.changePassForm.controls['newpassword'].hasError('required') ||
    this.changePassForm.controls['newpassword'].hasError(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/change-password/change-password.component.ts